
// Part name
export const REQUEST_RESET_USER_URL = 'auth/reset/user';
export const SEND_EMAIL_COMPLETE = 'Send email complete.Please check your email';